<form [formGroup]="formGroup">
  <country-wrapper>
    <ng-template country="NZ">
      <lds-numeric-input
        formControlName="phone"
        [label]="label"
        [allowLeadingZeros]="allowLeadingZeros"
        [isRequired]="isRequired"
        [minlength]="7"
        [maxlength]="12"
        placeholder="06XXXXXXXX"
        (sparkPasteNumbersOnly)="onPasteDigits($event)"
        [validations]="{
          required: 'Mobile number is required',
          phoneNumberValidator: 'Must be a valid phone number'
        }">
      </lds-numeric-input>
    </ng-template>
    <ng-template countryDefault>
      <lds-numeric-input
        formControlName="phone"
        [label]="label"
        [allowLeadingZeros]="allowLeadingZeros"
        [isRequired]="isRequired"
        [minlength]="6"
        [maxlength]="11"
        placeholder="03XXXXXXXX"
        (sparkPasteNumbersOnly)="onPasteDigits($event)"
        [validations]="{
          required: 'Phone number is required',
          phoneNumberValidator: 'Please enter a valid AU phone number'
        }">
      </lds-numeric-input>
    </ng-template>
  </country-wrapper>
</form>
